<!-- eslint-disable -->
<template>
  <div>
    <!-- Backdrop -->
    <transition name="crm-fade">
      <div v-if="visible" class="crm-filter-backdrop" @click="$emit('close')"></div>
    </transition>

    <!-- Panel -->
    <transition name="crm-slide-right">
      <div v-if="visible" class="crm-filter-panel">
        <!-- Header -->
        <div class="crm-filter-panel__header">
          <div class="crm-filter-panel__header-left">
            <feather-icon icon="SlidersIcon" size="18" />
            <h3 class="crm-filter-panel__title">Advanced Filters</h3>
          </div>
          <button class="crm-filter-panel__close" @click="$emit('close')">
            <feather-icon icon="XIcon" size="18" />
          </button>
        </div>

        <!-- Scrollable body -->
        <div class="crm-filter-panel__body">
          <!-- Stage Filter -->
          <div class="crm-filter-panel__section">
            <h4 class="crm-filter-panel__section-title">
              <feather-icon icon="ColumnsIcon" size="14" />
              Stage
            </h4>
            <div class="crm-filter-panel__checkboxes">
              <label
                v-for="stage in stages"
                :key="stage.id"
                class="crm-filter-panel__checkbox"
              >
                <input
                  type="checkbox"
                  :value="stage.id"
                  :checked="localFilters.stages.includes(stage.id)"
                  @change="toggleArrayFilter('stages', stage.id)"
                />
                <span class="crm-filter-panel__checkmark"></span>
                <span class="crm-filter-panel__checkbox-dot" :style="{ background: stage.color }"></span>
                <span class="crm-filter-panel__checkbox-label">{{ stage.name }}</span>
              </label>
            </div>
          </div>

          <!-- Priority Filter -->
          <div class="crm-filter-panel__section">
            <h4 class="crm-filter-panel__section-title">
              <feather-icon icon="AlertTriangleIcon" size="14" />
              Priority
            </h4>
            <div class="crm-filter-panel__checkboxes">
              <label
                v-for="p in priorityOptions"
                :key="p.value"
                class="crm-filter-panel__checkbox"
              >
                <input
                  type="checkbox"
                  :value="p.value"
                  :checked="localFilters.priorities.includes(p.value)"
                  @change="toggleArrayFilter('priorities', p.value)"
                />
                <span class="crm-filter-panel__checkmark"></span>
                <span class="crm-filter-panel__checkbox-dot" :style="{ background: p.color }"></span>
                <span class="crm-filter-panel__checkbox-label">{{ p.label }}</span>
              </label>
            </div>
          </div>

          <!-- Owner Filter -->
          <div class="crm-filter-panel__section">
            <h4 class="crm-filter-panel__section-title">
              <feather-icon icon="UsersIcon" size="14" />
              Owner / Assignee
            </h4>
            <div class="crm-filter-panel__checkboxes">
              <label
                v-for="owner in owners"
                :key="owner"
                class="crm-filter-panel__checkbox"
              >
                <input
                  type="checkbox"
                  :value="owner"
                  :checked="localFilters.owners.includes(owner)"
                  @change="toggleArrayFilter('owners', owner)"
                />
                <span class="crm-filter-panel__checkmark"></span>
                <span class="crm-filter-panel__checkbox-avatar">{{ owner.charAt(0) }}</span>
                <span class="crm-filter-panel__checkbox-label">{{ owner }}</span>
              </label>
            </div>
          </div>

          <!-- Labels Filter -->
          <div class="crm-filter-panel__section">
            <h4 class="crm-filter-panel__section-title">
              <feather-icon icon="TagIcon" size="14" />
              Labels
            </h4>
            <div class="crm-filter-panel__checkboxes">
              <label
                v-for="label in labels"
                :key="label.name"
                class="crm-filter-panel__checkbox"
              >
                <input
                  type="checkbox"
                  :value="label.name"
                  :checked="localFilters.labels.includes(label.name)"
                  @change="toggleArrayFilter('labels', label.name)"
                />
                <span class="crm-filter-panel__checkmark"></span>
                <span class="crm-filter-panel__checkbox-dot" :style="{ background: label.color }"></span>
                <span class="crm-filter-panel__checkbox-label">{{ label.name }}</span>
              </label>
            </div>
          </div>

          <!-- Date Range -->
          <div class="crm-filter-panel__section">
            <h4 class="crm-filter-panel__section-title">
              <feather-icon icon="CalendarIcon" size="14" />
              Due Date Range
            </h4>
            <div class="crm-filter-panel__date-range">
              <div class="crm-filter-panel__date-field">
                <label class="crm-filter-panel__date-label">From</label>
                <input
                  type="date"
                  class="crm-filter-panel__date-input"
                  :value="localFilters.dateRange.from"
                  @input="updateDateRange('from', $event.target.value)"
                />
              </div>
              <div class="crm-filter-panel__date-field">
                <label class="crm-filter-panel__date-label">To</label>
                <input
                  type="date"
                  class="crm-filter-panel__date-input"
                  :value="localFilters.dateRange.to"
                  @input="updateDateRange('to', $event.target.value)"
                />
              </div>
            </div>
          </div>

          <!-- Toggle: Has Checklist -->
          <div class="crm-filter-panel__section">
            <h4 class="crm-filter-panel__section-title">
              <feather-icon icon="CheckSquareIcon" size="14" />
              Has Checklist
            </h4>
            <div class="crm-filter-panel__toggles">
              <button
                v-for="opt in toggleOptions"
                :key="'cl-' + opt.value"
                class="crm-filter-panel__toggle-btn"
                :class="{ 'crm-filter-panel__toggle-btn--active': localFilters.hasChecklist === opt.value }"
                @click="setToggleFilter('hasChecklist', opt.value)"
              >
                {{ opt.label }}
              </button>
            </div>
          </div>

          <!-- Toggle: Has Attachments -->
          <div class="crm-filter-panel__section">
            <h4 class="crm-filter-panel__section-title">
              <feather-icon icon="PaperclipIcon" size="14" />
              Has Attachments
            </h4>
            <div class="crm-filter-panel__toggles">
              <button
                v-for="opt in toggleOptions"
                :key="'at-' + opt.value"
                class="crm-filter-panel__toggle-btn"
                :class="{ 'crm-filter-panel__toggle-btn--active': localFilters.hasAttachments === opt.value }"
                @click="setToggleFilter('hasAttachments', opt.value)"
              >
                {{ opt.label }}
              </button>
            </div>
          </div>

          <!-- Saved Presets -->
          <div v-if="savedPresets.length > 0" class="crm-filter-panel__section">
            <h4 class="crm-filter-panel__section-title">
              <feather-icon icon="BookmarkIcon" size="14" />
              Saved Presets
            </h4>
            <div class="crm-filter-panel__presets">
              <button
                v-for="preset in savedPresets"
                :key="preset.name"
                class="crm-filter-panel__preset-btn"
                @click="loadPreset(preset)"
              >
                <feather-icon icon="ZapIcon" size="12" />
                {{ preset.name }}
                <span class="crm-filter-panel__preset-remove" @click.stop="removePreset(preset.name)">
                  <feather-icon icon="XIcon" size="11" />
                </span>
              </button>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="crm-filter-panel__footer">
          <button class="crm-filter-panel__footer-btn crm-filter-panel__footer-btn--secondary" @click="clearAll">
            <feather-icon icon="RotateCcwIcon" size="14" />
            Clear All
          </button>
          <button class="crm-filter-panel__footer-btn crm-filter-panel__footer-btn--outline" @click="promptSavePreset">
            <feather-icon icon="SaveIcon" size="14" />
            Save Preset
          </button>
          <button class="crm-filter-panel__footer-btn crm-filter-panel__footer-btn--primary" @click="applyAndClose">
            <feather-icon icon="CheckIcon" size="14" />
            Apply
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'FilterPanel',

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    stages: {
      type: Array,
      required: true,
    },
    owners: {
      type: Array,
      required: true,
    },
    labels: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      localFilters: this.cloneFilters(this.filters),
      savedPresets: [],
      priorityOptions: [
        { value: 'High', label: 'High', color: '#ef4444' },
        { value: 'Medium', label: 'Medium', color: '#2563eb' },
        { value: 'Low', label: 'Low', color: '#10b981' },
      ],
      toggleOptions: [
        { value: null, label: 'Any' },
        { value: true, label: 'Yes' },
        { value: false, label: 'No' },
      ],
    }
  },

  watch: {
    filters: {
      handler(newVal) {
        this.localFilters = this.cloneFilters(newVal)
      },
      deep: true,
    },
    visible(val) {
      if (val) {
        this.localFilters = this.cloneFilters(this.filters)
      }
    },
  },

  created() {
    this.loadPresetsFromStorage()
  },

  methods: {
    cloneFilters(f) {
      return {
        searchQuery: f.searchQuery || '',
        stages: f.stages ? [...f.stages] : [],
        priorities: f.priorities ? [...f.priorities] : [],
        owners: f.owners ? [...f.owners] : [],
        labels: f.labels ? [...f.labels] : [],
        dateRange: f.dateRange
          ? { from: f.dateRange.from, to: f.dateRange.to }
          : { from: null, to: null },
        hasChecklist: f.hasChecklist !== undefined ? f.hasChecklist : null,
        hasAttachments: f.hasAttachments !== undefined ? f.hasAttachments : null,
      }
    },

    toggleArrayFilter(key, value) {
      const arr = this.localFilters[key]
      const idx = arr.indexOf(value)
      if (idx > -1) {
        arr.splice(idx, 1)
      } else {
        arr.push(value)
      }
      this.$emit('filter-change', { key, value: [...arr] })
    },

    updateDateRange(field, value) {
      this.$set(this.localFilters.dateRange, field, value || null)
      this.$emit('filter-change', {
        key: 'dateRange',
        value: { ...this.localFilters.dateRange },
      })
    },

    setToggleFilter(key, value) {
      this.$set(this.localFilters, key, value)
      this.$emit('filter-change', { key, value })
    },

    clearAll() {
      this.$emit('clear-all')
    },

    applyAndClose() {
      this.$emit('close')
    },

    promptSavePreset() {
      const name = prompt('Enter a name for this filter preset:')
      if (name && name.trim()) {
        const preset = {
          name: name.trim(),
          filters: this.cloneFilters(this.localFilters),
        }
        this.savedPresets.push(preset)
        this.savePresetsToStorage()
        this.$emit('save-preset', preset)
      }
    },

    loadPreset(preset) {
      const f = preset.filters
      // Emit each filter key
      Object.keys(f).forEach((key) => {
        if (key !== 'searchQuery') {
          this.$emit('filter-change', { key, value: f[key] })
        }
      })
      this.localFilters = this.cloneFilters(f)
    },

    removePreset(name) {
      this.savedPresets = this.savedPresets.filter((p) => p.name !== name)
      this.savePresetsToStorage()
    },

    savePresetsToStorage() {
      try {
        localStorage.setItem('crm-filter-presets', JSON.stringify(this.savedPresets))
      } catch (e) {
        // ignore
      }
    },

    loadPresetsFromStorage() {
      try {
        const raw = localStorage.getItem('crm-filter-presets')
        if (raw) {
          this.savedPresets = JSON.parse(raw)
        }
      } catch (e) {
        this.savedPresets = []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$primary: #2563eb;
$primary-dark: #1d4ed8;
$success: #10b981;
$warning: #2563eb;
$danger: #f43f5e;
$slate-50: #f8fafc;
$slate-100: #f1f5f9;
$slate-200: #e2e8f0;
$slate-300: #cbd5e1;
$slate-400: #94a3b8;
$slate-500: #64748b;
$slate-600: #475569;
$slate-700: #334155;
$slate-900: #0f172a;

/* ── Backdrop ── */
.crm-filter-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.3);
  backdrop-filter: blur(2px);
  z-index: 1039;
}

/* ── Panel ── */
.crm-filter-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 360px;
  height: 100vh;
  background: #fff;
  z-index: 1040;
  display: flex;
  flex-direction: column;
  box-shadow: -8px 0 40px rgba(0, 0, 0, 0.12);

  /* ── Header ── */
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 20px;
    border-bottom: 1px solid $slate-200;
    flex-shrink: 0;
  }

  &__header-left {
    display: flex;
    align-items: center;
    gap: 10px;
    color: $slate-700;
  }

  &__title {
    font-size: 16px;
    font-weight: 700;
    color: $slate-900;
    margin: 0;
    font-family: 'Outfit', 'Inter', sans-serif;
  }

  &__close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    background: $slate-100;
    border-radius: 8px;
    color: $slate-500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: $slate-200;
      color: $slate-700;
    }
  }

  /* ── Body ── */
  &__body {
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: $slate-300;
      border-radius: 2px;
    }
  }

  /* ── Sections ── */
  &__section {
    margin-bottom: 22px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12.5px;
    font-weight: 600;
    color: $slate-500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0 0 10px 0;
    font-family: 'Outfit', 'Inter', sans-serif;
  }

  /* ── Checkboxes ── */
  &__checkboxes {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__checkbox {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 7px 10px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.15s ease;
    user-select: none;

    &:hover {
      background: $slate-50;
    }

    input[type="checkbox"] {
      display: none;
    }
  }

  &__checkmark {
    width: 16px;
    height: 16px;
    border: 1.5px solid $slate-300;
    border-radius: 4px;
    flex-shrink: 0;
    position: relative;
    transition: all 0.2s ease;

    &::after {
      content: '';
      position: absolute;
      top: 2px;
      left: 4.5px;
      width: 4.5px;
      height: 8px;
      border: solid #fff;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg) scale(0);
      transition: transform 0.15s ease;
    }
  }

  &__checkbox input:checked + &__checkmark {
    background: $primary;
    border-color: $primary;

    &::after {
      transform: rotate(45deg) scale(1);
    }
  }

  &__checkbox-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__checkbox-avatar {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: linear-gradient(135deg, $primary, $primary-dark);
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__checkbox-label {
    font-size: 13px;
    color: $slate-700;
    font-weight: 500;
  }

  /* ── Date Range ── */
  &__date-range {
    display: flex;
    gap: 10px;
  }

  &__date-field {
    flex: 1;
  }

  &__date-label {
    display: block;
    font-size: 11.5px;
    font-weight: 500;
    color: $slate-500;
    margin-bottom: 4px;
  }

  &__date-input {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid $slate-200;
    border-radius: 8px;
    font-size: 13px;
    color: $slate-700;
    background: $slate-50;
    outline: none;
    font-family: 'Outfit', 'Inter', sans-serif;
    transition: all 0.2s ease;

    &:focus {
      border-color: $primary;
      box-shadow: 0 0 0 3px rgba($primary, 0.1);
      background: #fff;
    }
  }

  /* ── Toggle buttons ── */
  &__toggles {
    display: flex;
    gap: 6px;
  }

  &__toggle-btn {
    flex: 1;
    padding: 7px 10px;
    border: 1px solid $slate-200;
    background: #fff;
    border-radius: 8px;
    font-size: 12.5px;
    font-weight: 500;
    color: $slate-500;
    cursor: pointer;
    font-family: 'Outfit', 'Inter', sans-serif;
    transition: all 0.2s ease;

    &:hover {
      border-color: $slate-300;
      color: $slate-700;
    }

    &--active {
      background: $primary;
      border-color: $primary;
      color: #fff;

      &:hover {
        background: $primary-dark;
        border-color: $primary-dark;
        color: #fff;
      }
    }
  }

  /* ── Presets ── */
  &__presets {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  &__preset-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 10px;
    border: 1px solid $slate-200;
    background: $slate-50;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    color: $slate-600;
    cursor: pointer;
    font-family: 'Outfit', 'Inter', sans-serif;
    transition: all 0.2s ease;

    &:hover {
      border-color: $primary;
      color: $primary;
      background: #fff;
    }
  }

  &__preset-remove {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    color: $slate-400;
    transition: all 0.15s ease;

    &:hover {
      background: rgba($danger, 0.1);
      color: $danger;
    }
  }

  /* ── Footer ── */
  &__footer {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 14px 20px;
    border-top: 1px solid $slate-200;
    flex-shrink: 0;
    background: $slate-50;
  }

  &__footer-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 9px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    font-family: 'Outfit', 'Inter', sans-serif;
    transition: all 0.2s ease;
    white-space: nowrap;
    border: 1px solid transparent;

    &--secondary {
      background: #fff;
      border-color: $slate-200;
      color: $slate-600;

      &:hover {
        background: $slate-50;
        color: $slate-700;
        border-color: $slate-300;
      }
    }

    &--outline {
      background: transparent;
      border-color: $primary;
      color: $primary;

      &:hover {
        background: rgba($primary, 0.05);
      }
    }

    &--primary {
      flex: 1;
      background: $primary;
      color: #fff;

      &:hover {
        background: $primary-dark;
        box-shadow: 0 4px 12px rgba($primary, 0.3);
      }
    }
  }
}

/* ── Transitions ── */
.crm-fade-enter-active,
.crm-fade-leave-active {
  transition: opacity 0.25s ease;
}

.crm-fade-enter,
.crm-fade-leave-to {
  opacity: 0;
}

.crm-slide-right-enter-active,
.crm-slide-right-leave-active {
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.crm-slide-right-enter,
.crm-slide-right-leave-to {
  transform: translateX(100%);
}
</style>
